import {capitalizeFirst} from '@wandb/weave/core/util/string';

import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getXAxisFormatDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currXAxisFormatOption = currTemplateLinePlotSettings?.xAxisFormat;

  const newXAxisFormatOption = currWorkspaceLinePlotSettings?.xAxisFormat;
  const newXAxisFormatOptionValue =
    newXAxisFormatOption ?? DEFAULT_LINE_PLOT_SETTINGS.xAxisFormat;

  return {
    label: 'X axis format',
    field: 'xAxisFormat' as keyof LinePlotTemplateSettings,
    currValue: currXAxisFormatOption,
    currDisplayValue:
      currXAxisFormatOption == null
        ? undefined
        : capitalizeFirst(currXAxisFormatOption),
    newValue: newXAxisFormatOptionValue,
    newDisplayValue: newXAxisFormatOptionValue
      ? capitalizeFirst(newXAxisFormatOptionValue)
      : undefined,
  };
};
